import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">豆花视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              免费在线观看高清影视，汇集西瓜视频、芒果视频、丝瓜视频等优质资源，电影大全电视剧全集免费看。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/movie" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">电影大全</Link></li>
              <li><Link to="/category/tv-series" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">电视剧全集</Link></li>
              <li><Link to="/category/variety" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">综艺娱乐</Link></li>
              <li><Link to="/category/anime" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">动漫动画</Link></li>
              <li><Link to="/category/documentary" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">纪录片</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/category/documentary" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">纪录片推荐</Link></li>
              <li><Link to="/category/short-video" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">短视频</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">友情链接</h4>
            <ul className="space-y-2">
              <li><span className="text-sm text-background-400">西瓜视频免费</span></li>
              <li><span className="text-sm text-background-400">芒果视频</span></li>
              <li><span className="text-sm text-background-400">丝瓜视频</span></li>
              <li><span className="text-sm text-background-400">免费视频网站91</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">© 2024-2026 豆花视频 douhua.example.com 版权所有 | 免费在线观看高清影视</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow"><i className="ri-wechat-line text-lg"></i></a>
            <a href="#" className="text-background-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow"><i className="ri-weibo-line text-lg"></i></a>
            <a href="#" className="text-background-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow"><i className="ri-bilibili-line text-lg"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
}